import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export type ArtifactFormSkeletonProps = {
  fields?: number
  ariaLabel?: string
  className?: string
}

export function ArtifactFormSkeleton({
  fields = 5,
  ariaLabel = 'Loading form',
  className,
}: ArtifactFormSkeletonProps) {
  return (
    <div
      className={cn('space-y-6', className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={ariaLabel}
    >
      {Array.from({ length: fields }).map((_, index) => (
        <div key={index} className="space-y-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-full" />
        </div>
      ))}
    </div>
  )
}

/** Analysis panel: org + job selects + history card. */
export function SmartSearchPanelSkeleton({
  ariaLabel = 'Loading analysis',
  className,
}: {
  ariaLabel?: string
  className?: string
}) {
  return (
    <div
      className={cn('space-y-6', className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={ariaLabel}
    >
      <Skeleton className="h-24 w-full rounded-xl" />
      <div className="space-y-4 rounded-lg border p-4">
        <Skeleton className="h-5 w-32" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-full" />
        </div>
        <div className="space-y-2">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-10 w-full" />
        </div>
        <Skeleton className="h-10 w-36" />
      </div>
      <Skeleton className="h-32 w-full rounded-lg" />
    </div>
  )
}
